import React from "react";
import styles from './Map.module.scss'

export const Map = () => {
    const googleMapsApiKey = process.env.REACT_APP_MAPS_API_KEY || ''

    return <iframe loading="lazy" allowFullScreen className={styles.mapsIframe} title={'Mapa'}
    src={`https://www.google.com/maps/embed/v1/search?q=Meble+Krobia,+Długa,+Krobia,+Polska&key=${googleMapsApiKey}`}/>
}